module.exports = __webpack_public_path__ + "img/dessert-1.16c43a4b.jpg";